import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const ONPREM_R7_API_INTEGRATION = getFeature('onprem-r7-api-integration') || false;
